// extracted by mini-css-extract-plugin
export var attachment = "_p6-a";
export var emailContainer = "_p6-4";
export var emailContentPaddedContainer = "_p6-b";
export var emailHeader = "_p6-6";
export var emailIframe = "_p6-3";
export var emailInfoIcon = "_p6-9";
export var emailShortenedSummary = "_p6-e";
export var infoDropdown = "_p6-0";
export var infoRowBoundedContent = "_p6-d";
export var internal = "_p6-5";
export var merchant = "_p6-8";
export var messageInputContainer = "_p6-h";
export var normal = "_p6-7";
export var replyCard = "_p6-f";
export var subtleButton = "_p6-1";
export var subtleButtonIconContainer = "_p6-2";
export var toggleViewRepliesButton = "_p6-c";
export var wrappingText = "_p6-g";